<body>
<mat-card class="card"> <img class="logo1" src="../../../assets/img/flat-lay-photography-of-vegetable-salad-on-plate-1640777.jpg">
    <form class="form1">
        
            <span class="title">Enter OTP</span>
            <span></span>

            <div class="row1">
                <mat-form-field  class=""><mat-label>OTP</mat-label>
                    <input  matInput placeholder="Enter Your OTP"></mat-form-field> 
            </div>
            <div class="row1">
                    <button  mat-button class="btn1" (click)="submit()">Submit</button>
           
            </div>
        

        </form>    
    </mat-card>
</body>